import React, { useState } from "react";
import Comunidades from "./components/comunidades";
import Provincias from "./components/provincias";

let comunidadSeleccionada;

const ComboApp = () => {

  const [comunidadesValue, setComunidadesValue] = useState("");
  const [ProvinciasOpciones, setProvinciasOpciones] = useState([]);

  const handleComunidadesChange = (event) => {

    const selectedValue = event.target.value;
    comunidadSeleccionada = selectedValue;

    // Limpiamos siempre porque si cambia, cambian los municipios
    // Cargamos el segundo combo y ya se verá

    // Da igual que se la opción 0.

    document.getElementById("mensaje").innerHTML = ``;

    setComunidadesValue(selectedValue);

    switch (selectedValue) {
      case "Euskadi":
        setProvinciasOpciones(["Araba", "Gipuzkoa", "Bizkaia"]);
        break;
      case "Canarias":
        setProvinciasOpciones(["Las Palmas", "Tenerife"]);
        break;
      case "Aragon":
        setProvinciasOpciones(["Zaragoza", "Huesca", "Teruel"]);
        break;
      default:
        setProvinciasOpciones([]);
    }
    
  };

  const handleProvinciasChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue.length > 0) {
      document.getElementById("mensaje").innerHTML = 
             `<br>La provincia seleccionada es <b>${selectedValue}</b> 
             y la comunidad es <b>${comunidadSeleccionada}</b>`;
    } else {
      document.getElementById("mensaje").innerHTML = ``;
    }
  };

  return (
    <>
      <div>
        <Comunidades handleChange={handleComunidadesChange} />{" "}
        <br/>
        <Provincias opciones={ProvinciasOpciones} 
                    handleChange={handleProvinciasChange} />{" "}
      </div>{" "}
      <div id="mensaje"> </div>{" "}
    </>
  );
};

export default ComboApp;
